/**
 * @param {String} key
 */
export function getSearchParam(key) {
  return (new RegExp(`[?&]${key}=([^&]+)`).exec(window.location.search) || [])[1];
}

/**
 * TODO 保留 hash
 * @param {*} key
 * @param {*} sourceURL
 */
export function removeParam(sourceURL, key) {
  let ret = sourceURL.split('?')[0];
  const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    const paramsArr = queryString.split('&') || [];
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      const param = paramsArr[i].split('=')[0];
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    ret = `${ret}?${paramsArr.join('&')}`;
  }
  return ret;
}

export function parseURL(url) {
  const a = document.createElement('a');
  a.href = url;
  return {
    source: url,
    protocol: a.protocol.replace(':', ''),
    host: a.hostname,
    port: a.port,
    query: a.search,
    // eslint-disable-next-line func-names
    params: (function () {
      const ret = {};
      const seg = a.search.replace(/^\?/, '').split('&');
      const len = seg.length; let i = 0; let
        s;
      for (;i < len; i++) {
        // eslint-disable-next-line no-continue
        if (!seg[i]) { continue; }
        s = seg[i].split('=');
        ret[s[0]] = s[1];
      }
      return ret;
    }()),
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
    hash: a.hash.replace('#', ''),
    path: a.pathname.replace(/^([^\/])/, '/$1'),
    // eslint-disable-next-line no-sparse-arrays
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
    segments: a.pathname.replace(/^\//, '').split('/'),
  };
}
export function objectToString(objectData) {
  if (!(objectData instanceof Object)) { return; }
  const keyList = Object.keys(objectData);
  let str = '';
  for (const val of keyList) {
    str += `${val}=${objectData[val]}&`;
  }

  str.slice(0, str.length - 1);
  // eslint-disable-next-line consistent-return
  return str;
}
